export function normalizeQualityName(value: string): string {
  return value.replace(/[\s\u0085\u200B]/g, "")
}
